import Imgix from 'react-imgix';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Animation } from '../../../theme/Animation.es.js';
import '../../../theme/Colors.es.js';
import { Shadows } from '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import 'react';

const Styles = labelStyles("Img", {
  root: css`
    all: unset;
    box-sizing: border-box;
    transition: box-shadow ${Animation.transitionDuration}
      ${Animation.transitionTimingFunction};
    max-width: 100%;
  `
});
const Img = ({ src, alt = "", "aria-hidden": ariaHidden = void 0, aspectRatio = void 0, borderRadius = "medium", className = void 0, height = void 0, isBlock = void 0, isFullWidth = void 0, loading = "lazy", objectFit = void 0, objectPosition = void 0, onError = void 0, onLoad = void 0, shadow = void 0, sizes = void 0, width = void 0 }) => {
  const sharedProps = {
    // Avoid styling conflicts by only applying either
    // `props.className` or `Styles.root`.
    className,
    css: className ? void 0 : Styles.root,
    height,
    alt,
    "aria-hidden": ariaHidden,
    "data-testid": "img",
    loading,
    onError,
    onLoad,
    sizes,
    src,
    width,
    // These styles are all highly dynamic and therefore aren't
    // useful to create classes for since the permutations
    // could result in many classes, so apply as inline styles
    // instead. Only apply if `className` isn't defined in order
    // to avoid style conflicts.
    style: !className ? {
      display: isBlock ? "block" : void 0,
      width: isFullWidth ? "100%" : width,
      height,
      borderRadius: `var(--zds-radius-${borderRadius})`,
      boxShadow: shadow && Shadows[shadow],
      objectFit,
      objectPosition,
      overflow: "hidden"
    } : void 0
  };
  if (!src.includes("imgix.net")) {
    return (
      // `alt` is in `sharedProps` but eslint plugin doesn't see it
      // eslint-disable-next-line jsx-a11y/alt-text
      jsx("img", Object.assign({}, sharedProps))
    );
  }
  return jsx(Imgix, { className: sharedProps.className, css: sharedProps.css, height: sharedProps.height, htmlAttributes: {
    alt: sharedProps.alt,
    "aria-hidden": sharedProps["aria-hidden"],
    "data-testid": sharedProps["data-testid"],
    loading: sharedProps.loading,
    onError: sharedProps.onError,
    onLoad: sharedProps.onLoad,
    style: sharedProps.style
  }, imgixParams: {
    ar: aspectRatio,
    // v9.x of react-imgix implements the default behavior of the Imgix API
    // which is to use `fit=clip`. This LOC re-introduces the v8.x behavior
    // which previously attached `fit=crop` whenever aspect ratio, height,
    // or width properties were applied.
    // See https://github.com/imgix/react-imgix#8x-to-90
    fit: aspectRatio || width || height || sizes ? "crop" : void 0
  }, sizes: sharedProps.sizes, src: sharedProps.src, width: sharedProps.width });
};

export { Img };
//# sourceMappingURL=Img.es.js.map
